// Manages active state of links in subnavigation list
(() => {

    const currentURL = window.location.href

    const links = document.querySelectorAll('.sandro-subnavigation li[data-collection-handle]')
    links.forEach(link => {

        const handle = link.getAttribute('data-collection-handle')
        if (currentURL.includes(handle)) link.setAttribute('active', true)
    })

})()

// Manages product or model view for product grid
const collectionViewManager = () => {

    const setCollectionView = (view, { product, model }) => {
            if (view === 'model') {
                product.forEach(image => image.dataset.activeView = false)
                model.forEach(image => image.dataset.activeView = true)
            } else {
                product.forEach(image => image.dataset.activeView = true)
                model.forEach(image => image.dataset.activeView = false)
            }
    }

    const buttons = document.querySelectorAll('button[data-sandro-view]')
    const images = {
        product: document.querySelectorAll('.sandro-collection-grid img[data-sandro-featured-image="product"]'),
        model: document.querySelectorAll('.sandro-collection-grid img[data-sandro-featured-image="model"]') 
    }

    buttons.forEach(button => {

        if(button.getAttribute('data-active-view') === 'true') {
            const view = button.getAttribute('data-sandro-view')
            setCollectionView(view, images)
        }

        button.addEventListener('click', (e) => {
            e.preventDefault()
            const view = button.getAttribute('data-sandro-view')

            setCollectionView(view, images)

            buttons.forEach(button => {
                button.getAttribute('data-sandro-view') !== view 
                    ? button.removeAttribute('data-active-view') 
                    : button.setAttribute('data-active-view', true)
            })
        })
    })
}


// Manages height of banner in product grid
const bannerHeightManager = () => {
    console.log('resizing banners')
    const banner = document.querySelector('.sandro-special-banner')
    if (!banner) return
    
    const cardMediaSampleHeight = document.querySelector('img[data-sandro-featured-image]').offsetHeight

    banner.style.height = `${cardMediaSampleHeight}px`
}

// window.addEventListener('resize', () => {
//     bannerHeightManager()
// })

bannerHeightManager()
collectionViewManager()